import { useEffect, useRef, useState } from 'react';

interface Config {
  defaultHeight?: number;
}

export const useElementHeight = <T extends HTMLElement>(
  element: T | null,
  config?: Config
) => {
  const elementRef = useRef(element);
  const [elementHeight, setElementHeight] = useState(
    elementRef.current?.clientHeight || config?.defaultHeight || 0
  );

  useEffect(() => {
    if (!elementRef.current || !window.MutationObserver) return;
    const mutationObserver = new MutationObserver(
      onElementMutation(elementRef, setElementHeight)
    );
    mutationObserver.observe(elementRef.current, {
      childList: true,
      subtree: true,
    });
    return () => mutationObserver.disconnect();
  }, []);

  return elementHeight;
};

const onElementMutation = (
  elementRef: React.MutableRefObject<HTMLElement | null>,
  setElementHeight: (height: number) => void,
  defaultHeight?: number
) => () => {
  const { current } = elementRef;
  setElementHeight(current ? current.clientHeight : defaultHeight || 0);
};
